import React, { Component } from 'react';
import {
  getTooltipMessage,
  canDeletePostOrComment
} from '../../../utils/functions';
import TimeSince from '../../TimeSince';
import Icon, { TYPE_LIKE, TYPE_TRASH } from '../../Icon';
import CommentIcon from '../../Icon/CommentIcon';
import ActionIcon from '../../ActionIcon/index';
import './Comment.css';

class Comment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeleting: false
    };
  }

  canDelete(comment) {
    return canDeletePostOrComment(this.props.user, comment);
  }

  deleteComment(post, comment) {
    this.setState({ isDeleting: true }, () => {
      this.props.onDeleteComment(post.id, comment);
    });
  }

  render() {
    const { comment, post, onLikeComment, onUnlikeComment } = this.props;

    return (
      <li className="comment-list-item">
        <div className="comment-specifics">
          <CommentIcon />
          <div className="comment-body-container">
            <span className="feed-message-author-name">
              {comment.author.displayName}
            </span>
            <span className="feed-message-comment-body">
              {' '}
              {comment.comment}
            </span>
            <div className="comment-footer">
              <span className="post-time">
                <TimeSince date={comment.created} />
              </span>
              {this.canDelete(comment) && (
                <Icon
                  type={TYPE_TRASH}
                  onClick={() => {
                    !this.state.isDeleting && this.deleteComment(post, comment);
                  }}
                  disabled={this.state.isDeleting}
                  name="comment"
                />
              )}
              <ActionIcon
                count={comment.likeCount}
                filled={comment.likedByMe}
                title="Like this comment"
                tooltipMessage={getTooltipMessage(comment.likes, object => {
                  return object.displayName;
                })}
                type={TYPE_LIKE}
                onClick={() =>
                  comment.likedByMe
                    ? onUnlikeComment(comment)
                    : onLikeComment(comment)}
              />
            </div>
          </div>
        </div>
      </li>
    );
  }
}

export default Comment;



// WEBPACK FOOTER //
// ./src/components/CommentList/Comment/index.js